"use strict";
/**
 * Types for the Rewards + Deposit bundle program.
 *
 * A bundle applicant originates a Rewards Card via the /rewards-checking landing page and is
 * offered a 0% APY Aven Checking account (0% APY). Funding $25k unlocks a 5% cashback boost on the
 * Rewards Card. Underwriting is identical to a regular Rewards Card applicant, so bundle
 * membership is tracked per loan application via a dedicated enrollment record.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsCheckingBundleAskVariant = exports.RewardsDepositBundleEnrollmentStatus = void 0;
/**
 * Lifecycle of a Rewards + Deposit bundle enrollment.
 * - pendingFunding: enrolled at origination; awaiting the $25k Checking deposit that unlocks the boost
 * - active: the $25k funding requirement was met and the 5% boost is live on the Rewards Card
 * - suspended: the maintained-balance requirement lapsed; reverted to the standard rewards tier
 * - expired: the funding window elapsed without qualifying, or the enrollment was otherwise terminated
 */
var RewardsDepositBundleEnrollmentStatus;
(function (RewardsDepositBundleEnrollmentStatus) {
    RewardsDepositBundleEnrollmentStatus["pendingFunding"] = "pendingFunding";
    RewardsDepositBundleEnrollmentStatus["active"] = "active";
    RewardsDepositBundleEnrollmentStatus["suspended"] = "suspended";
    RewardsDepositBundleEnrollmentStatus["expired"] = "expired";
})(RewardsDepositBundleEnrollmentStatus || (exports.RewardsDepositBundleEnrollmentStatus = RewardsDepositBundleEnrollmentStatus = {}));
var RewardsCheckingBundleAskVariant;
(function (RewardsCheckingBundleAskVariant) {
    RewardsCheckingBundleAskVariant["openAccount"] = "openAccount";
    RewardsCheckingBundleAskVariant["fundAccount"] = "fundAccount";
})(RewardsCheckingBundleAskVariant || (exports.RewardsCheckingBundleAskVariant = RewardsCheckingBundleAskVariant = {}));
